import type { components } from '@slims-pro/api-client';
import type { ProFleetPlantCard, ProPlantOption, ProTone } from '@slims-pro/ui/organisms';
import { type FormatOptions, kw, pct, peakPower } from '@/lib/format';

type PlantSummary = components['schemas']['PlantSummary'];
type AssetStatus = components['schemas']['AssetStatus'];

const STATUS_TONE: Record<AssetStatus, ProTone> = {
	ok: 'green',
	warning: 'amber',
	fault: 'red',
	offline: 'muted',
};

/** Fleet card: KPI order and labels from mock v4.5 `renderFleet`. */
export function toFleetPlantCard(p: PlantSummary, o: FormatOptions = {}): ProFleetPlantCard {
	const s = p.snapshot;
	const inverters =
		s?.invertersOnline != null && s.invertersTotal != null
			? `${s.invertersOnline}/${s.invertersTotal}`
			: '-';
	return {
		id: p.id,
		name: p.name,
		location: `${p.location} · ${p.kind === 'utility' ? 'Campo a terra' : 'C&I'}`,
		statusTone: STATUS_TONE[p.status],
		kpis: [
			{ label: 'Live', value: kw(s?.livePowerKw, o) },
			{ label: 'PR', value: pct(s?.prPct, o) },
			{ label: 'Potenza', value: peakPower(p.peakPowerKwp, o) },
			{ label: 'Inverter', value: inverters },
		],
		footer: p.customerName ?? undefined,
	};
}

export function toPlantOption(p: PlantSummary): ProPlantOption {
	return { id: p.id, label: `${p.name} · ${p.location}` };
}
